export type StatusProp = {
    id: string
    icon: string
    color: string
    title?: string
    subtitle?: string
    subtitle2?: string
    background: string
}

export enum LICENSE_STATUS {
    'VALID' = 'VALID',
    'EXPIRED' = 'EXPIRED',
    'ABOUT_RENEW' = 'ABOUT_RENEW'
}

export const statusDefault: StatusProp[] = [
    {
        id: LICENSE_STATUS.VALID,
        title: 'Valid',
        icon: 'far fa-check-circle',
        color: 'green-700', // class from theme Live
        background: 'green-200'
    },
    {
        id: LICENSE_STATUS.ABOUT_RENEW,
        title: 'About to Renew',
        icon: 'far fa-exclamation-circle',
        color: 'yellow-700',
        background: 'yellow-500'
    },
    {
        id: LICENSE_STATUS.EXPIRED,
        title: 'Expired',
        icon: 'far fa-exclamation-triangle',
        color: 'red-700',
        background: 'red-300'
    }
]

export const getStatus = (id: string): StatusProp => {
    return statusDefault.find(ele => ele.id === id)
}
